import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material"
import { useAppSelector } from "../../../../../../../../hooks/store-hooks"
import { useListaCEPService } from "../../../../../../../../../use-cases/geo-veles"
import { useState } from "react"
import { formatCep } from "../../../../../../../../../utils"

export const EditCEP = (props: {
    openEditCEP: boolean
    oldCEP: string
}) => {
    // State
    const { listaCEP } = useAppSelector((state) => state)
    // Use State
    const [newCep, setNewCep] = useState<string>(props.oldCEP)
    // Hook
    const { openEditCEP, listaCEPEditCEP } = useListaCEPService()

    const handleClose = () => {
        openEditCEP(false);
    };

    return (
        <>
            {
                props.openEditCEP === true &&
                <Dialog
                    open={listaCEP.openEditCEP}
                    onClose={handleClose}
                    hideBackdrop
                >
                    <DialogTitle>Editar CEP</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Digite abaixo o novo CEP atualizado.
                        </DialogContentText>
                        <Box mt={3}>
                            <TextField
                                InputLabelProps={{
                                    shrink: true
                                }}
                                autoFocus
                                value={newCep}
                                margin="dense"
                                label="Digite o novo CEP"
                                type="text"
                                fullWidth
                                variant="standard"
                                onChange={(e) => {
                                    setNewCep(e.target.value)
                                }}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleClose}
                        >
                            Cancelar
                        </Button>
                        <Button
                            autoFocus
                            onClick={() => {
                                handleClose()
                                listaCEPEditCEP({
                                    cep: props.oldCEP,
                                    newCEP: formatCep(newCep)
                                })
                            }}
                        >
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}